module.exports = __webpack_public_path__ + "img/newsImg3-3.788f674b.png";